import script from "./PreSaleCommPlan518.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreSaleCommPlan518.vue?vue&type=script&setup=true&lang=ts"

import "./PreSaleCommPlan518.vue?vue&type=style&index=0&id=7487c22a&lang=less&scope=true"

const __exports__ = script;

export default __exports__